var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"300px","width":"100%","border":"1px"}},[_c('YsMonacoEditor',{ref:"monacoRef",attrs:{"height":300,"options":_vm.options,"value":_vm.fvalue},on:{"change":_vm.monacoChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }